import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent2 } from "util";

const states = [
  {
    name: "app.registration.product.inventory.modify.xml",
    url: "/entrada-por-xml",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/modify/xml/index.js